import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { IoFunnel } from "react-icons/io5";

import * as userActions from "../../actions/userActions";
import * as modalActions from "../../actions/modalActions";

import UserList from "./UserList";
import HeaderWrapper from "../common/HeaderWrapper";
import ConfirmModal from "../common/ConfirmModal";
import UserFilters from "./UserFilters";

class UserPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      loading: false,
      filteredUsers: []
    };
  }

  componentDidMount = () => {
    // the only place that we should be loading all users
    this.props.actions.loadAllUsers();
  };

  onClickAdd = () => {
    this.props.history.push("/app/settings/users/add");
  };

  onClickView = (id) => {
    this.props.history.push(`/app/settings/users/${id}`);
  };

  onClickDelete = (userId) => {
    this.props.actions.requestUserId(userId);
  };

  openFilters = () => {
    this.setState({ open: !this.state.open });
  };

  filter = (e) => {
    this.setState({ search: e.target.value });
  };

  handleDelete = () => {
    this.props.actions.deleteUser(this.props.userToDelete);
  };

  handleToggle = async (user) => {
    user.is_active = !user.is_active;
    await this.props.actions.updateUser(user, "toggle");
  };

  render() {
    const { allUsers, isMobile } = this.props;
    const { search, filteredUsers } = this.state;

    return (
      <React.Fragment>
        <HeaderWrapper
          breadcrumbs={[{ label: "Settings" }, { label: "Users" }]}
          onClickAdd={this.onClickAdd}
          onClickAction={[{ action: this.openFilters, icon: <IoFunnel /> }]}
          onClickChild={this.clickChild}
          onFilter={this.filter}
          isMobile={isMobile}
        />
        {this.state.open && (
          <UserFilters
            loading={this.state.loading}
            open={this.state.open}
            setFilteredUsers={(users) =>
              this.setState({
                filteredUsers: users
              })
            }
            setLoading={(isLoading) =>
              this.setState({
                loading: isLoading
              })
            }
          />
        )}
        <div className="content-wrapper">
          <UserList
            loading={this.state.loading}
            users={filteredUsers.length ? filteredUsers : allUsers}
            search={search}
            isMobile={isMobile}
            onToggle={this.handleToggle}
            onClickDelete={this.onClickDelete}
            onClickView={this.onClickView}
          />
          <ConfirmModal
            id="userDeleteModal"
            title="Delete User"
            body="Are you sure you want to delete this user?"
            close={this.props.actions.hideModal}
            confirm={this.handleDelete}
          />
        </div>
      </React.Fragment>
    );
  }
}

UserPage.propTypes = {
  actions: PropTypes.object,
  history: PropTypes.object,
  allUsers: PropTypes.array.isRequired,
  userToDelete: PropTypes.string,
  isMobile: PropTypes.bool
};

function mapStatesToProps(state) {
  return {
    state: state.reducers,
    allUsers: state.reducers.allUsers,
    userToDelete: state.reducers.userToDelete
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...userActions, ...modalActions }, dispatch)
  };
}

export default connect(mapStatesToProps, mapDispatchToProps)(UserPage);
